import ban1 from "../../assets/img/home-banner/ban1.jpg";
import ban1lg from "../../assets/img/home-banner/ban1lg.jpg";
import ban1sm from "../../assets/img/home-banner/ban1sm.jpg";
import homaprch1 from "../../assets/img/homaprch1.jpg";
import homefitment1 from "../../assets/img/homefitment.jpg";
import ClientCaroucel from "../plugins/ClientCarousel";
import ClientMarque from "../plugins/ClientMarque";
import { Helmet } from "react-helmet-async";
import HelemtHead from "../commons/HelmetHead";
const Home = () => {
    return (
        <>
            <div className="page page_home z-2">
                {/* <HelemtHead title={'Home'} name={'description'} desc={'Some random description'} /> */}
                <Helmet>
                    <title>FirstResource || Team of insightful recruiters</title>
                    <meta name='description' content='We eliminate the guesswork in talent acquisition.Our specialized Resume Level (L1) selection guarantees only candidates who fit seamlessly with your needs, reducing the challenge of sorting through resumes' />
                    <meta name="keywords"
                        content="FirstResource, firstresource, first resource, recruitment, recruiters, talent acquisition, hiring, staffing, job placement, workforce solutions, recruitment agency, employment services, candidate sourcing, recruitment solutions, talent management, HR services, recruitment consultancy" />
                </Helmet>
                <div className="section banner ">
                    <div className="bannerin w-100 h-100">
                        <div className="slides w-100 h-100">
                            <div className="slide position-absolute left-0 top-0 w-100 h-100">
                                <picture>
                                    <source srcSet={ban1lg} media="(min-width: 1440px)" />
                                    <source srcSet={ban1sm} media="(max-width: 768px)" />
                                    <source srcSet={ban1} />
                                    <img src={ban1} alt="Home banner" className="w-100 h-100 object-fit-cover home_banner" />
                                </picture>
                                <div className="position-absolute bottom-0 start-0 end-0 home_banner_text">
                                    <div className="container mb-5 text-white position-relative z-1 px-4 px-lg-0">
                                        <h1 className="display-1 fw-bold ">Delivering Zero Rejections</h1>
                                        <h3 className="">We eliminate the guesswork in talent acquisition.Our specialized Resume Level (L1) selection guarantees only candidates who fit seamlessly with your needs, reducing the challenge of sorting through resumes</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section effotrs">
                    <div className="container py-5 px-4 px-lg-0">
                        <div className="row">
                            <div className="col-12 col-lg-6">
                                <h2 className="display-2 fwlight">Effortless,
                                    Effective Hiring</h2>
                            </div>
                            <div className="col-12 col-lg-6">
                                <p className="fs-1 text-secondary">First Resource is a team of
                                    insightful recruiters who help
                                    drive great business value.</p>
                                <p className="fs-3 fwmed text-body-secondary">Our in-depth understanding of your
                                    industry and talent requirements means we
                                    deliver resumes that perfectly align with
                                    your needs, reducing your workload and
                                    ensuring top-quality candidates right from
                                    the first stage.</p>
                                <p className="fs-3 fwmed text-body-secondary">Experience a talent acquisition process
                                    that's thorough, thoughtful, and tailored to
                                    your success.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section approach bg-light">
                    <div className="backstage">

                        <div className="half_face">
                            <img src={homaprch1} alt="img" />
                        </div>
                    </div>
                    <div className="container position-relative py-5 z-1 px-4 px-lg-0">
                        <div className="row">
                            <div className="col-12 mb-5">
                                <div className="title">
                                    <div className="titlein">Our Approach</div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-7 d-flex">
                                <div className="desc ms-auto">
                                    <p className="fs-4 fwmed">Our proprietary 4-stage vetting process is built to
                                        filter candidates meticulously, so only the best reach
                                        your desk. We combine industry expertise with a
                                        commitment to zero rejection, ensuring that every
                                        resume we forward aligns with your goals and
                                        requirements.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section customers">
                    <div className="container px-4 px-lg-0">
                        <div className="row align-items-center">
                            <div className="col-12 col-lg-8">
                                {/* <ClientCaroucel /> */}
                                <ClientMarque />
                            </div>
                            <div className="col-12 col-lg-4">
                                <h2 className="display-4 fwbold mt-5 mt-lg-0 mb-lg-5"><span className="text-secondary">Our</span> <span className="text-body-secondary">Customers</span></h2>
                                <p className="fs-4 fw-medium mb-3">Helping you retain your competitive edge so that we may retain ours
                                </p>
                                <p className="fs-4 "> If your talent acquisition has obstacles than outcomes, we're your optimisation all-rounders. Partner with us for smart solutions that make hiring easy.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section fitment">
                    <div className="cover">
                        <img src={homefitment1} alt="" />
                    </div>
                    <div className="position-absolute bottom-0 start-0 end-0">
                        <div className="container mb-5 pb-5 text-white">
                            <h2 className="display-4 fwbold text-dark">Perfect fitment. Happily onboarded</h2>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}
export default Home;